import React, {Fragment, PureComponent} from 'react';
import {FormInput} from '@homeaway/react-form-components';
import {Field} from 'redux-form';
import {FormattedMessage} from 'react-intl';
import {DebounceInput} from 'react-debounce-input';

import GiftCardPhotoUploader from '../GiftCardPhotoUploader/GiftCardPhotoUploader';
import {
    validateCertificateNumber,
    validateOrderId
} from '../../../utils/validations';
import {SECURITY_MESSAGE, CERTIFICATE_NUMBER_LABEL, ORDER_ID_LABEL, GIFT_CARD_INFORMATION_TEXT, ADD_PHOTO_TEXT} from '../../../utils/constants';

import './GiftCardInformation.less';

const CERTIFICATE_NUMBER_LABEL_TEXT = (
    <FormattedMessage
        id="giftCardCertificateNumberText"
        defaultMessage={CERTIFICATE_NUMBER_LABEL}
    />
);

const ORDER_ID_LABEL_TEXT = (
    <FormattedMessage
        id="giftCardOrderIDText"
        defaultMessage={ORDER_ID_LABEL}
    />
);

const GIFT_CARD_INFORMATION_LABEL = (
    <FormattedMessage
        id="giftCardInformationText"
        defaultMessage={GIFT_CARD_INFORMATION_TEXT}
    />
);

export const ADD_PHOTO_LABEL = (
    <FormattedMessage
        id="giftCardAddPhotoText"
        defaultMessage={ADD_PHOTO_TEXT}
    />
);

const SECURITY_MESSAGE_LABEL = (
    <FormattedMessage
        id="giftCardAddPhotoMessage"
        defaultMessage={SECURITY_MESSAGE}
    />
);

export default class GiftCardInformation extends PureComponent {
    state = {
        orderErrorMsg: '',
        certificateErrorMsg: ''
    };

    componentWillUnmount() {
        const {giftCardCount} = this.props;
        this.props[`orderId${giftCardCount}`].input.onChange('');
        this.props[`certificateNumber${giftCardCount}`].input.onChange('');
        this.props[`giftCardImageUploader${giftCardCount}`].input.onChange('');
    }

    // onBlur
    handleOrderIdBlur = (e) => {
        const orderError = validateOrderId(e.target.value);
        if (orderError) {
            this.setState({
                orderErrorMsg: orderError
            });
        }
    };

    handleCertificateNumberBlur = (e) => {
        const certificateError = validateCertificateNumber(e.target.value);
        if (certificateError) {
            this.setState({
                certificateErrorMsg: certificateError
            });
        }
    };

    // onChange
    handleOrderIdChange = (e) => {
        this.props[`orderId${this.props.giftCardCount}`].input.onChange(e.target.value);
        this.setState({orderErrorMsg: ''});
    };

    handleCertificateNumberChange = (e) => {
        this.props[
            `certificateNumber${this.props.giftCardCount}`
        ].input.onChange(e.target.value);
        this.setState({certificateErrorMsg: ''});
    };

    renderCertificateNumber = () => {
        const {
            input: {value},
            meta: {error}
        } =
            (this.props.giftCardCount >= 0 &&
                this.props[`certificateNumber${this.props.giftCardCount}`]);

        const {certificateErrorMsg} = this.state;
        const errorText = error || certificateErrorMsg;

        return (
            <div className="GiftCardInformation__Fields">
                <DebounceInput
                    debounceTimeout={300}
                    element={FormInput}
                    id="certificateNumber"
                    type="text"
                    name={`certificateNumber${this.props.giftCardCount}`}
                    label={CERTIFICATE_NUMBER_LABEL_TEXT}
                    errorMsg={errorText}
                    value={value}
                    onChange={this.handleCertificateNumberChange}
                    onBlur={this.handleCertificateNumberBlur}
                />
            </div>
        );
    };

    renderOrderId = () => {
        const {
            input: {value},
            meta: {error}
        } =
            (this.props.giftCardCount >= 0 &&
                this.props[`orderId${this.props.giftCardCount}`]);
        const {orderErrorMsg} = this.state;
        const errorText = error || orderErrorMsg;
        return (
            <div className="GiftCardInformation__Fields">
                <DebounceInput
                    debounceTimeout={300}
                    element={FormInput}
                    id="orderId"
                    type="number"
                    name={`orderId${this.props.giftCardCount}`}
                    label={ORDER_ID_LABEL_TEXT}
                    errorMsg={errorText}
                    value={value}
                    onChange={this.handleOrderIdChange}
                    onBlur={this.handleOrderIdBlur}
                />
            </div>
        );
    };

    render() {
        const {giftCardCount, giftCardErrors} = this.props;
        return (
            <Fragment>
                <div className="GiftCardInformation__Title" key={`GiftCardInformation__Title${giftCardCount}`}>{GIFT_CARD_INFORMATION_LABEL}</div>
                <div className="GiftCardInformation">
                    {this.renderCertificateNumber()}
                    {this.renderOrderId()}
                </div>
                <div className="GiftCardInformation__PhotoUploader">
                    <span className="GiftCard__Title">{ADD_PHOTO_LABEL}{': '}</span>
                    <span className="Security_message">{SECURITY_MESSAGE_LABEL}</span>
                    <Field
                        name={`giftCardImageUploader${this.props.giftCardCount}`}
                        giftCardCount={this.props.giftCardCount}
                        component={GiftCardPhotoUploader}
                        required
                        giftCardErrors={giftCardErrors}
                    />
                </div>
            </Fragment>
        );
    }
}
